const formatMoney = (number) => {
  return parseFloat(number).toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ")
}

export default formatMoney